import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import SleepScreenVideoPreview from './SleepScreenVideoPreview';
import styles from './SleepScreenCreatedModal.module.css';

const truncateUrl = (url) => {
  if (!url) return '';
  if (url.length <= 60) return url;
  return `${url.slice(0, 30)}...${url.slice(-25)}`;
};

const SleepScreenCreatedModal = ({ entry, onClose }) => {
  if (!entry) return null;

  const handleAssign = () => {
    // Phase 4 stub — assignment tool not yet built.
    toast.info('Fridge assignment is coming in Phase 4.');
    onClose();
  };

  return (
    <Modal show={Boolean(entry)} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Entry created</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={styles.confirmBanner}>
          <span className={styles.checkmark}>✓</span>
          <div className={styles.confirmText}>
            <strong>{entry.displayName}</strong>
            <span>added to the library</span>
          </div>
        </div>

        <div className={styles.prompt}>Assign this screen to fridges now?</div>
        <div className={styles.promptBody}>
          New entries don&apos;t run anywhere until they&apos;re assigned to one
          or more fridges. You can also do this later from the library.
        </div>

        <div className={styles.entryCard}>
          <SleepScreenVideoPreview url={entry.videoUrl} />
          <div className={styles.entryMeta}>
            <span className={styles.entryName}>{entry.displayName}</span>
            <span className={styles.entryUrl}>
              {truncateUrl(entry.videoUrl)}
            </span>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className={styles.footerButtons}>
          <button
            type="button"
            className={styles.notNowButton}
            onClick={onClose}
          >
            not now
          </button>
          <button
            type="button"
            className={styles.assignButton}
            onClick={handleAssign}
          >
            assign to fridges →
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

SleepScreenCreatedModal.propTypes = {
  entry: PropTypes.shape({
    displayName: PropTypes.string,
    videoUrl: PropTypes.string,
  }),
  onClose: PropTypes.func.isRequired,
};

SleepScreenCreatedModal.defaultProps = {
  entry: null,
};

export default SleepScreenCreatedModal;
